import React, { useEffect, useState } from "react";
import { useLanguageForShared } from "../../../../../../../shared/utils/languages/useLanguageForShared";
import { useTemplateFormOxigen } from "../data/useTemplateFormOxigen";
import { useTemplateFormOtherInfo } from "../data/useTemplateFormOtherInfo";
import { useParamsData } from "../data/useParamsData";
import { useEffectOnlyUpdate } from "../../../../../../../shared/utils/use_custom/useEffectCustom";
import { copyObject } from "../../../../../../../shared/utils/objUtils";
import { FormElements } from "../../../../../../../shared/bootstrap/form/FormElements";
import FormGroup from "../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import InputCustom from "../../../../../../../shared/bootstrap/form/input/InputCustom";
import { useTemplateFormConcentratorFixed } from "../data/useTemplateFormConcentratorFixed";

const ConcentratorTemplateFixed = ({ dataForm, changeValue, setData, errors, isSubmit }) => {
  const { t } = useLanguageForShared();
  const [sum, setSum] = useState();
  const {
    formStructurePathologies,
    formStructurePrescription,
    formStructureValid
  } = useTemplateFormConcentratorFixed(t, dataForm);
  const {
    formStructureCannulaNasal, formStructureMask,
    formStructureDetailCannulaNasal, formStructureDetailMask
  } = useTemplateFormOtherInfo(t, dataForm);
  const {
    formStructureNote
  } = useParamsData(t, dataForm);
  
  useEffectOnlyUpdate(() => {
    if (!dataForm?.cannulaNasal) {
      const modeField = formStructureDetailCannulaNasal.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.cannulaNasal]);

  useEffect(() => {
    if (!dataForm?.mask) {
      const modeField = formStructureDetailMask.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.mask]);
  const getValue = (val) => {
    return val ? parseInt(val) : 0;
  };
  useEffect(() => {
    setSum(getValue(dataForm?.nightFlowHourDie) + getValue(dataForm?.underStressFlowHourDie) + getValue(dataForm?.flowRestHourDie));
  }, [dataForm?.nightFlowHourDie, dataForm?.underStressFlowHourDie, dataForm?.flowRestHourDie]);
    const changePathologyData = (data, val) => {

        if(dataForm?.pathology?.includes("Other") && data.name === 'pathology' && !data.value.includes("Other")){
            changeValue({
                value: {
                    pathology:data.value,
                    otherPathologies: ''
                }
            })
        } else {
            changeValue(data)
        }

    }
  return (
    <>
      <FormElements
        structure={formStructurePathologies}
        dataForm={dataForm}
        changeValue={changePathologyData}
        isSubmit={isSubmit}
        errors={errors}
      />

      <p className={"title-paragraph"}>{t('sg.prescription')}</p>
      <FormElements
        structure={formStructurePrescription}
        dataForm={dataForm}
        changeValue={changeValue}
        isSubmit={isSubmit}
        errors={errors}
      />

      <div className="row">
        <div className="col-sm-12 col-lg-3">
          <FormGroup
            label={{ label: t("prescription.template.check24h.label") }}
            error={{
              isVisible: sum > 24,
              message: t("prescription.template.check24h.error")
            }}
          >
            <InputCustom
              type={"text"}
              name={"check24h"}
              error={sum > 24}
              value={sum}
              disabled={true}
            />
          </FormGroup>
        </div>
        <div className="col-sm-12 col-lg-3">
          <FormElements
            isSubmit={isSubmit}
            structure={formStructureValid}
            dataForm={dataForm}
            changeValue={changeValue}
            errors={errors}
          />
        </div>
      </div>

      <p className={"title-paragraph"}>{t('sg.otherInfo')}</p>
      <FormElements
        structure={formStructureCannulaNasal}
        dataForm={dataForm}
        isSubmit={isSubmit}
        changeValue={changeValue}
        errors={errors}
      />
      <FormElements
        structure={formStructureMask}
        dataForm={dataForm}
        isSubmit={isSubmit}
        changeValue={changeValue}
        errors={errors}
      />
      <FormElements
        structure={formStructureNote}
        dataForm={dataForm}
        isSubmit={isSubmit}
        changeValue={changeValue}
        errors={errors}
      />
    </>
  );
};


export default ConcentratorTemplateFixed;
